import createAxiosInstance from './axiosConfig';
import { OriginadorDTO } from '../shared/dto/originadorDTO';

const { REACT_APP_ESTEIRA_BACK } = process.env;

const axiosInstance = createAxiosInstance(REACT_APP_ESTEIRA_BACK + '/rest/originadorController');

export default class OriginadorService {
  axios: any;

  constructor() {
    this.axios = axiosInstance;
  }
  
  async listarTodasOriginadoresPorRole() {
    return await this.axios.get(`/listarTodosOriginadoresPorRole`);
  };

  async ativarInativarOriginador(id: string) {
    return await this.axios.get(`/ativarInativarOriginador?id=${id}`);
  };

  async listarOriginadorPorId(id: string) {
    return await this.axios.get(`/listarOriginadorPorId?id=${id}`);
  };

async incluirAlterarOriginador(originadorDTO: OriginadorDTO) {
  return await this.axios.post(`/incluirAlterarOriginador`, originadorDTO);
};

  async listarTodosOriginadoresAtivos() {
    return await this.axios.get(`/listarTodosOriginadoresAtivos`);
  };

  async listarPorMatriz(matrizId: string) {
     return await this.axios.get(`/listarPorMatriz?idMatriz=${matrizId}`);
  };

  async listarOriginador(page: number, size: number, filters: any) {
    const params = new URLSearchParams();
    
    params.append('page', String(page));
    params.append('size', String(size));

    for (const key in filters) {
      if (filters[key]) {
        params.append(key, filters[key]);
      }
    }
    return await this.axios.get(`/listar`, { params });
  };
}